/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_File_DownloadInputs */

const cs_chat_file_download = /** @type {(inputs: Chat_File_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stáhnout`)
};

const en_chat_file_download = /** @type {(inputs: Chat_File_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

/**
* | output |
* | --- |
* | "Download" |
*
* @param {Chat_File_DownloadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_file_download = /** @type {((inputs?: Chat_File_DownloadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_File_DownloadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_file_download(inputs)
	return cs_chat_file_download(inputs)
});